import React, { useState, useEffect, useContext } from 'react';
import { PulseLoader } from 'react-spinners';
import moment from 'moment';

import httpClient from '../../api/httpClient';
import { getFilterFormattedDateTime } from '../../utils/dateUtils';
import StolpediagramVertikalt from '../Statistikk/StolpediagramVertikalt';
import SporingsdataInfo from '../Driftskart/SporingsdataInfo.tsx';
import { LocaleContext } from '../../Locale/LocaleProvider';

import './DashboardDriftsstatistikk.scss';

const DashboardDriftsstatistikkUtfortTiltak = () => {
  const localeContext = useContext(LocaleContext);

  const [timer, setTimer] = useState();
  const [shouldUpdate, setShouldUpdate] = useState(true);
  const [datoFra, setDatoFra] = useState();
  const [datoTil, setDatoTil] = useState();

  const [tiltakStatistikkdata, setTiltakStatistikkdata] = useState({});

  const getData = () => {
    setShouldUpdate(true);
    const filter = {
      omrade: [
        {
          id: '00000000-0000-0000-0000-000000000000',
          navn: 'Alle områder',
        },
      ],
      kategoriId: [
        {
          id: '97867e05-f508-4457-8a67-f9c8f8dd236c',
          navn: 'Vinterdrift',
        },
      ],
      arbeidstype: [],
      seksjonId: [],
    };

    const fra = moment().subtract(1, 'day').format();
    setDatoFra(fra);

    const til = moment().format();
    setDatoTil(til);

    setTiltakStatistikkdata({ loading: true });
    httpClient
      .getStatistikkTiltakPrEntreprenor(
        getFilterFormattedDateTime(fra),
        getFilterFormattedDateTime(til),
        filter
      )
      .then((data) => {
        setTiltakStatistikkdata(data);
      });
    setShouldUpdate(false);
  };

  useEffect(() => {
    getData();

    setTimer(
      setInterval(() => {
        getData();
      }, 900000) //  Henter data hvert 15 minutt
    );
  }, []);

  return (
    <>
      <div className="statistikkPage-dashboard">
        <div className="statistikkPage-dashboard-chart-container">
          {tiltakStatistikkdata && !tiltakStatistikkdata.loading ? (
            <>
              <div>
                <h1>
                  {
                    localeContext.currentLocale.messages[
                      'diagram-container.antall-km-utfort-tiltak.tittel'
                    ]
                  }
                </h1>
                <h3>Vei / Alle områder / Alle typer arbeid / Km</h3>
              </div>

              <StolpediagramVertikalt
                tooltipVerdiPostfix="km"
                data={tiltakStatistikkdata.statistikk}
                ingenDataTekst="#"
              />
            </>
          ) : (
            <PulseLoader loading color="#fff" />
          )}
        </div>
      </div>
      <div className="statistikkPage-dashboard-sub">
        <h2>Siste 24 timer</h2>
        <SporingsdataInfo shouldUpdate={shouldUpdate} />
        <p>Sist oppdatert: {moment(datoTil).format('DD.MM.YY - HH:mm')}</p>
      </div>
    </>
  );
};

export default DashboardDriftsstatistikkUtfortTiltak;
